module.exports = __webpack_public_path__ + "img/semFoto.8537a38b.jpg";